exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group.select {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-direction: column;\r\n      flex-direction: column;\r\n}\r\n.form-group.select select {\r\n  width: 100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/goal-task-edit/goal-task-edit.component.css
// module id = ../../../../../src/app/goal-task-edit/goal-task-edit.component.css
// module chunks = main